// config.js
// const BASE_URL = 'http://127.0.0.1:5459';
// const BASE_URL = 'http://172.233.82.184:5459';
// const BASE_URL = '/api';

// export { BASE_URL };

export const BASE_URL = process.env.REACT_APP_BASE_URL;